module.exports = __webpack_public_path__ + "img/iconRefresh.a15fad85.svg";